import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'Icon card grid',
    defaultMessage: 'Graella icones',
  },
  columns: {
    id: 'Icon card grid columns',
    defaultMessage: 'Columnes',
  },
});

export const IconCardGridSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.title),
  fieldsets: [{ id: 'default', title: 'Default', fields: ['columns'] }],
  properties: {
    columns: {
      title: intl.formatMessage(messages.columns),
      widget: 'select',
      choices: [
        ['2', '2 columnes'],
        ['3', '3 columnes'],
      ],
      default: '2',
    },
  },
  required: [],
});
